import { gql } from '@apollo/client';

export const CREATE_FACEBOOK_AD_INTEGRATION = gql`
  mutation CreateFacebookAdIntegration(
    $request: CreateFacebookAdIntegrationRequest!
  ) {
    CreateFacebookAdIntegration(request: $request) {
      id
    }
  }
`;

export const UPDATE_FACEBOOK_AD_INTEGRATION = gql`
  mutation UpdateFacebookAdIntegration(
    $id: String!
    $request: UpdateFacebookAdIntegrationRequest!
  ) {
    UpdateFacebookAdIntegration(id: $id, request: $request) {
      id
    }
  }
`;
